// extracted by mini-css-extract-plugin
module.exports = {"info":"_344","item":"_17802","label":"_10343","value":"_14399","top":"_18561","status":"_6822","bottom":"_13478","images":"_8184","image":"_10025","tips":"_6815","arrow":"_7374"};